import { FormsySelect } from '@thanx/uikit/select'
import { Text } from '@thanx/uikit/text'
import ColorPicker from 'components/Form/ColorPicker'
import Section from 'components/Section'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'

const text_align_OPTIONS = [
  { value: 'left', label: 'Left' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Right' },
]

type Props = {
  blockId: string
  contentBlock: ContentBlockData
}

const PersonalizedTextContentStyle = ({ blockId, contentBlock }: Props) => {
  const { settings } = contentBlock

  return (
    <Section className="flex-1 mb-l mr-xs p-l pt-0">
      <Text.Header4 className="mb-l">Custom Text</Text.Header4>
      <ColorPicker
        className="my-m"
        name={`${blockId}.settings.text_color`}
        label={'Text Color'}
        validations={{
          hex: true,
          isRequired: true,
        }}
        value={settings['text_color']}
        validationErrors={{
          hex: I18n.t('validations.hex.message'),
          isRequired: I18n.t('validations.is_required'),
        }}
        startEnhancer
      />
      <ColorPicker
        className="my-m"
        name={`${blockId}.settings.background_color`}
        label={'Background Color'}
        validations={{
          hex: true,
          isRequired: true,
        }}
        value={settings['background_color']}
        validationErrors={{
          hex: I18n.t('validations.hex.message'),
          isRequired: I18n.t('validations.is_required'),
        }}
        startEnhancer
      />
      <FormsySelect
        label={'Text Alignment'}
        options={text_align_OPTIONS}
        value={settings['text_align']}
        name={`${blockId}.settings.text_align`}
        placeholder={'Select'}
        validations={{
          isRequired: true,
        }}
        validationErrors={{
          isRequired: I18n.t('validations.is_required'),
        }}
      />
    </Section>
  )
}

export default PersonalizedTextContentStyle
